import * as React from 'react';

import GoalsSvg from '../assets/goals.svg';

import styles from './help-graphic-goals.module.css';

export class HelpGraphicGoals extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.goals}>
                <GoalsSvg />
            </div>
        );
    }
}
